// itarmi

export default [
	{elementType: "geometry", stylers: [{color: "#2c3b4e"}]},
	{elementType: "labels.text.stroke", stylers: [{color: "#242f3e"}]},
	{elementType: "labels.text.fill", stylers: [{color: "#707d86"}]},
	{
		featureType: "administrative.locality",
		elementType: "labels.text.fill",
		stylers: [{color: "#707d86"}],
	},
	{
		featureType: "poi",
		elementType: "labels.text.fill",
		stylers: [{color: "#707d86"}],
	},
	{
		featureType: "poi.park",
		elementType: "geometry",
		stylers: [{color: "#2c3b4e"}],
	},
	{
		featureType: "poi.park",
		elementType: "labels.text.fill",
		stylers: [{color: "#707d86"}],
	},
	{
		featureType: "road",
		elementType: "geometry",
		stylers: [{color: "#38414e"}],
	},
	{
		featureType: "road",
		elementType: "geometry.stroke",
		stylers: [{color: "#212a37"}],
	},
	{
		featureType: "road",
		elementType: "labels.text.fill",
		stylers: [{color: "#9ca5b3"}],
	},
	{
		featureType: "road.highway",
		elementType: "geometry",
		stylers: [{color: "#707d86"}],
	},
	{
		featureType: "road.highway",
		elementType: "geometry.stroke",
		stylers: [{color: "#29323f"}],
	},
	{
		featureType: "road.highway",
		elementType: "labels.text.fill",
		stylers: [{color: "#707d86"}],
	},
	{
		featureType: "transit",
		elementType: "geometry",
		stylers: [{color: "#2f3948"}],
	},
	{
		featureType: "transit.station",
		elementType: "labels.text.fill",
		stylers: [{color: "#707d86"}],
	},
	{
		featureType: "water",
		elementType: "geometry",
		stylers: [{color: "#17263c"}],
	},
	{
		featureType: "water",
		elementType: "labels.text.fill",
		stylers: [{color: "#515c6d"}],
	},
	{
		featureType: "water",
		elementType: "labels.text.stroke",
		stylers: [{color: "#17263c"}],
	},
];
